import moment from "moment";
import MomentInput = moment.MomentInput;
import {ValidEntityIntf} from "core/common/domain/commonDomain";
import leftPad from 'left-pad';

const DEFAULT_DATE_FORMAT = 'L';
const DEFAULT_DATETIME_FORMAT = "L LTS";
const DEFAULT_TIME_FORMAT = "HH:mm";

export const TIME_PATTERN_HH_mm = "^[0-2]?\\d:[0-5]\\d$";
export const TIME_PATTERN_HH_mm_ss = "^[0-2]?\\d:[0-5]\\d(:[0-5]\\d)?$";


export function formatInterval(valueFrom: MomentInput, valueTo: MomentInput, showInfinityInterval: boolean = true): string {
  let str =  ((valueFrom) ? moment(valueFrom).format(DEFAULT_DATE_FORMAT) : '\u221E') + ' - ' + ((valueTo) ? moment(valueTo).format(DEFAULT_DATE_FORMAT) : '\u221E')
  return (showInfinityInterval || valueFrom || valueTo) ? str : '';
}


export function isValid(objekt: ValidEntityIntf, keDni: MomentInput): boolean {
  if (!keDni) {
    return true;
  }
  let momentKeDni = moment(keDni);
  return (
    ( !objekt.validFrom || momentKeDni.isSameOrAfter(objekt.validFrom) )
    &&
    ( !objekt.validTo || momentKeDni.isSameOrBefore(objekt.validTo) )
  );
}

function formatAny(value: any, format: string) {
  if (!value) {
    return value;
  } else {
    const valueM = moment(value);
    if (valueM.isValid()) {
      return valueM.format(format);
    } else {
      return value;
    }
  }
}

export function formatPeriod(value: string, asHHmmss: boolean = false) {
  if (!value) {
    return value;
  } else {
    let duration = moment.duration(value);
    return (asHHmmss) ? ( leftPad(Math.trunc(duration.asHours()), 2, '0') + ":" + leftPad(duration.minutes(), 2, '0') + ((duration.seconds() > 0) ? ":" + leftPad(duration.seconds(), 2, '0') : "") ) : duration.humanize();
  }
}

/**
 * If value is date or moment or string as date, it is formateed, otherwise is just returned
 * @param value
 * @param format
 * @returns {*}
 */
export function formatDate(value: any, format: string = DEFAULT_DATE_FORMAT) {
  return formatAny(value, format);
}

export function formatDateIso(value: any) {
  return formatAny(value, "YYYY-MM-DD");
}


/**
 * If value is date or moment or string as date, it is formateed, otherwise is just returned
 * @param value
 * @param format
 * @returns {*}
 */
export function formatDateTime(value: any, format: string = DEFAULT_DATETIME_FORMAT) {
  return formatAny(value, format);
}

export function formatTime(value: any, format: string = DEFAULT_TIME_FORMAT) {
  return formatAny(value, format);
}


/**
 * setridi list objektu implementujicich ValidEntityIntf a zkontroluje ze se neprekryvaji,
 * vrati false pokud se prekryvaji nebo je validTo mensi nez validFrom na temze elementu
 *
 * @param interval
 * @param <T>
 * @return
 */
export function sortAndCheckInterval(intervals: ValidEntityIntf[]): boolean {
  if(!intervals || !intervals.length) return true;

  intervals = intervals.sort((o1, o2) => (!o1.validFrom) ? -1 : ( (!o2.validFrom) ? 1 : moment(o1.validFrom).valueOf() - moment(o2.validFrom).valueOf() ));

  let lowerBoundInfinityCount = 0, higherBoundInfinityCount = 0;
  let previousValue: ValidEntityIntf = null;

  for(let t of intervals) {
    if (!t.validFrom) lowerBoundInfinityCount++;
    if (!t.validTo) higherBoundInfinityCount++;
    if (t.validFrom && t.validTo &&  moment(t.validFrom).isAfter(t.validTo)) {
      return false;
    }
    if (previousValue) {
      if (!previousValue.validTo || !t.validFrom || !moment(previousValue.validTo).isBefore(t.validFrom)) {
        return false;
      }
    }
    previousValue = t;
  }

  if (lowerBoundInfinityCount > 1) return false;
  if (higherBoundInfinityCount > 1) return false;

  return true;
}


export function isFullMonth(start: MomentInput, end: MomentInput): boolean {
  let start2 = moment(start);
  start2.startOf("month");

  let end2 = moment(end);
  end2.endOf("month").startOf('day');

  return start2.isSame(start) && end2.isSame(end) && start2.month() === end2.month() && start2.year() === end2.year();
}


export function stripTime(datetime: Date) : Date {
  return new Date(datetime.setHours(0, 0, 0, 0));
}



// WEBPACK FOOTER //
// ./src/core/common/utils/dateUtils.ts